import React from 'react'
import styled from "styled-components";
import NopermissionImg from "@/img/no-permission.png";

const ContentDiv = styled.div`
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 160px 0;

  .img-div{
    width: 200px;
    height: 214px;

    img{
      width: 100%;
      height: 100%;
    }
  }

  .text-div{
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    margin: 40px 0 32px;
    text-align: center;
  }
`

const NoPermission = () => {
  return (
    <ContentDiv>
      <div className="img-div">
        <img src={NopermissionImg} alt="" />
      </div>
      <div className="text-div">
        <div>您当前不在该应用可见范围内，请联系您的管理员至企微后台修改</div>
      </div>
    </ContentDiv>
  )
}

export default NoPermission;
